<template>
  <div class="login" v-cloak v-if="tokenLog == 0">
    <div class="apply-con-top">
      <div class="p">登录入驻</div>
      <div class="name-con">
        <div class="name-input mg">
          <input
            type="text"
            maxlength="11"
            v-model="phone"
            placeholder="请输入手机号"
          />
        </div>
      </div>
      <div class="name-code">
        <div class="code-input mg">
          <input
            type="text"
            maxlength="6"
            v-model="code"
            placeholder="请输入验证码"
          />
          <div class="btnCode mg" @click="getCode(phone)" v-if="timeFlag">
            获取验证码
          </div>
          <div class="btnCode mg" style="color: #b1b1bb" v-else>
            {{ time }}s
          </div>
        </div>
      </div>
      <div class="bom-txt">
        <van-checkbox checked-color="#e03344" v-model="checked"
          >我已阅读并同意<span style="color: #505055" @click.stop="agreement"
            >《大众号入驻协议》</span
          ></van-checkbox
        >
      </div>
      <div class="but" @click="submitForm()">登录</div>
    </div>
  </div>
  <div id="c1"></div>
  <div v-if="tokenLog == 1">
    <div class="type-con" v-cloak v-if="showTheme == 0">
      <div class="type-list">
        <p class="title-top">请选择账号类型</p>
        <div
          class="item-type"
          v-for="(item, index) in typeList"
          :key="index"
          @click="goTheme(item)"
        >
          {{ item.name }}
        </div>
      </div>
    </div>
    <div class="certificate" v-cloak v-if="showTheme == 1">
      <p class="big-title">基本信息</p>
      <div class="apply-con-top">
        <div class="head-con">
          <p class="title-t">大众号LOGO</p>
          <div class="head-content">
            <!--            <label class="file" for="upload"></label>-->
            <!--            <input-->
            <!--              class="file"-->
            <!--              type="file"-->
            <!--              ref="files"-->
            <!--              id="upload"-->
            <!--              style="position: absolute; clip: rect(0 0 0 0)"-->
            <!--              @change="uploadImg($event, 1)"-->
            <!--            />-->
            <input
              type="file"
              style="opacity: 0"
              ref="files"
              class="file"
              accept="image/*"
              @change="uploadImg($event, 1)"
            />
            <img class="txt-img" :src="image" alt="" />
            <img class="head-img" :src="headImg" alt="" v-if="headImg" />
          </div>
        </div>
        <div class="name-con">
          <div class="name-input mg">
            <input
              type="text"
              v-model="publicName"
              minlength="2"
              maxlength="15"
              :placeholder="'大众号名称（2-15字）'"
            />
          </div>
        </div>
        <div class="name-con">
          <van-field
            class="name-input mg col"
            v-model="fieldValue"
            is-link
            readonly
            placeholder="所在城市"
            @click="showCity = true"
            right-icon="arrow-down"
          />
          <van-popup v-model:show="showCity" round position="bottom">
            <van-cascader
              v-model="cascaderValue"
              :options="options"
              @change="onChange"
              @close="showCity = false"
              active-color="#1989fa"
              :field-names="fieldNames"
              @finish="onFinish"
            />
          </van-popup>
        </div>
        <div class="inr-con">
          <div class="inr-input">
            <textarea
              minlength="10"
              v-model="info"
              maxlength="200"
              type="text"
              :placeholder="'账号简介（200字以内）'"
            ></textarea>
          </div>
        </div>
      </div>
      <div v-if="enterType != 1">
        <p class="big-title" style="margin-top: 16px">运营主体</p>
        <div class="apply-con-top">
          <div class="name-con">
            <div class="name-input">
              <input
                type="text"
                maxlength="30"
                v-model="nameUnit"
                placeholder="单位名称"
              />
            </div>
          </div>
          <div class="img-cons">
            <div class="head-content">
              <div class="img-item mg-tea" v-if="idImg">
                <input
                  type="file"
                  style="opacity: 0"
                  ref="filesff"
                  class="file"
                  accept="image/*"
                  @change="uploadImg($event, 2)"
                />
                <img :src="idImg" alt="" />
                <div class="txt-img">替换</div>
              </div>
              <div class="img-con mg-tea" v-else>
                <input
                  type="file"
                  style="opacity: 0"
                  ref="filesff"
                  class="file"
                  accept="image/*"
                  @change="uploadImg($event, 2)"
                />
                <img :src="imagePhoto" alt="" />
                <p>{{ toastTxt }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <p class="big-title" style="margin-top: 16px">
        {{ enterType == 1 ? "运营者" : "联系人" }}
      </p>
      <div class="apply-con-top">
        <div class="name-con">
          <div class="name-input">
            <input
              type="text"
              maxlength="10"
              v-model="name"
              :placeholder="enterType == 1 ? '真实姓名' : '联系人姓名'"
            />
          </div>
        </div>
        <div class="img-cons" v-if="enterType == 1">
          <div class="head-content">
            <div class="img-item mg-tea" v-if="idImg">
              <input
                type="file"
                style="opacity: 0"
                ref="filesff"
                class="file"
                accept="image/*"
                @change="uploadImg($event, 2)"
              />
              <img :src="idImg" alt="" />
              <div class="txt-img">替换</div>
            </div>
            <div class="img-con mg-tea" v-else>
              <input
                type="file"
                style="opacity: 0"
                ref="filesff"
                class="file"
                accept="image/*"
                @change="uploadImg($event, 2)"
              />
              <img :src="imagePhoto" alt="" />
              <p>{{ toastTxt }}</p>
            </div>
          </div>
        </div>
      </div>
      <div class="but-con">
        <div v-if="tokenLog">
          <div
            class="but"
            v-if="enterType == 1"
            :class="
              headImg && publicName && fieldValue && info && name && idImg
                ? ''
                : 'gray'
            "
            @click="submitInfo()"
          >
            {{ overTxt }}
          </div>
          <div
            class="but"
            v-else
            :class="
              headImg &&
              publicName &&
              fieldValue &&
              info &&
              name &&
              idImg &&
              nameUnit
                ? ''
                : 'gray'
            "
            @click="submitInfo()"
          >
            {{ overTxt }}
          </div>
        </div>
      </div>
    </div>
  </div>
  <img-cropper
    v-if="showShadow"
    :img="imgUrl"
    :auto-crop-width="autoCropWidth"
    :auto-crop-height="autoCropHeight"
    @ok="sure"
    @cancel="cancel"
  >
  </img-cropper>
  <!--  <div class="shadow" v-if="loading">-->
  <!--    <van-loading size="24px" color="#0094ff" vertical-->
  <!--      >图片上传中...</van-loading-->
  <!--    >-->
  <!--  </div>-->
</template>
<script>
import axios from "axios";
import { Base64 } from "js-base64";
import {
  toast,
  getIsApp,
  fileRandomKey,
  _isHarmonyOS,
} from "../assets/js/common";
import {
  getQiniuToken,
  tokenExpire,
  getInfo,
  getStatusByUser,
  sendCode,
  loginSms,
  areaList,
  getTypeList,
  register,
  modify,
  getSubChannelDetailByUser,
} from "../api/enter";
// eslint-disable-next-line no-unused-vars
import { showDialog, Loading, showLoadingToast } from "vant";
import { encrypt, generatekey, decryptAes } from "../utils/rsa";
// import imageClipper from "../components/imageClipper.vue";
import imgCropper from "../components/imgCropper";
const qiniuimgZone = "https://image.dzplus.dzng.com/";
const URL = "https://m.dzplus.dzng.com/"; // 下载app页面链接、入住协议公共地址域名 正式
// const URL = "https://test.m.dzplus.dzng.cc/"; // 下载app页面链接、入住协议公共地址域名 测试
export default {
  components: {
    "img-cropper": imgCropper,
  },
  data() {
    return {
      //图片裁切
      uptoken: "",
      showShadow: false,
      imgUrl: "",
      autoCropWidth: null,
      autoCropHeight: null,

      typeLists: [
        {
          name: "市县号",
          desc: "点击上传组织机构代码证或统一社会信用代码证",
        },
        {
          name: "个人号",
          desc: "点击上传身份证人像面",
        },
        {
          name: "企业号",
          desc: "点击上传营业执照或统一社会信用代码证",
        },
        {
          name: "政务号",
          desc: "点击上传组织机构代码证或统一社会信用代码证",
        },
        {
          name: "健康号",
          desc: "点击上传组织机构代码证或统一社会信用代码证",
        },
        {
          name: "教育号",
          desc: "点击上传组织机构代码证或统一社会信用代码证",
        },
        {
          name: "媒体号",
          desc: "点击上传组织机构代码证或统一社会信用代码证",
        },
      ],
      typeList: [],
      showTheme: -1,
      overTxt: "提交",
      title: "", // 大众号title名称
      enterType: "", // 大众号类型
      publicId: "", //大众号id
      headImg: "", //大众号logo
      publicName: "", //大众号名称
      info: "", // 简介
      nameUnit: "", // 单位名称
      idImg: "", // 上传证件
      name: "", //个人名字
      image: "https://img.qiluyidian.net/x68Jjk_1698659469076.png", // 大众号logo默认上传底部
      imagePhoto: "https://img.qiluyidian.net/n2R87D_1689583150135.png", // 大众号上传证件默认底部
      toastTxt: "上传盖章申请证明",
      checked: false, // 勾选入驻协议
      //  城市
      cityValue: "请选择地区信息",
      showCity: false,
      fieldNames: {
        text: "name",
        value: "id",
        children: "childrenNodes",
      },
      options: [],
      active: 1,
      fieldValue: "",
      cascaderValue: "",
      province: "",
      city: "",
      district: "",
      //  顶象验证
      time: 60,
      timer: null,
      timeFlag: true,
      phone: "",
      code: "",
      //手机号正确验证
      reg_tel:
        /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/,
      //身份证号验证
      reg_idCard: /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/,
      token: "", // 89e4eb0d-c422-4a19-ac3f-825621561952
      tokenLog: -1, // 判断token是否有效(登录是否有效)
      isFlutter: false, // 与客户端交互flutter
      version: "", // 版本号
      //  大众号各媒体对接关系：大众APP 1，大众日报 2，齐鲁晚报 3，海报新闻 4，农村大众 5，半岛都市报 6，
      //  鲁中晨报 7，经济导报 8，山东法制报 9，黄三角早报 10，青年记者 11
      sourceId: "", // 来源id
      sharingCode: "", // 分享码
      isApp: "", // 是否是app
      userId: "",
      // loading: false,
      tailHead: "?imageView2/1/w/320/h/320/interlace/1/q/100",
      tailID: "?imageView2/1/w/654/h/368/interlace/1/q/100",
      // 由于上传图片过大，上传后进行加参展示
    };
  },
  created() {
    //       const uploadInput = this.$refs.files
    // // 这里要根据不同系统来判断添加或删除capture
    //       uploadInput.setAttribute('capture','filesystem')
    // // 或者
    //       uploadInput.setAttribute('capture','environment')
    // // 或者
    //       uploadInput.removeAttribute('capture')
    let that = this;
    // eslint-disable-next-line no-unused-vars
    // let vConsole = new window.VConsole();
    that.$nextTick(() => {
      if (getIsApp()) {
        that.isApp = true;
      } else {
        that.isApp = false;
      }
    });
    if (that.tokenLog == 1 && that.showTheme == 1) {
      console.log("1" + that.publicId);
      document.title = that.publicId ? "修改信息" : `申请入驻${this.title}`;
    } else {
      console.log("2" + that.publicId);
      console.log(that.tokenLog);
      console.log(that.showTheme);
      document.title = that.publicId ? "修改信息" : `申请入驻${this.title}`;
    }
    that.getAreaList();
    that.getTypeLi();
  },
  mounted() {
    let that = this;
    window.addEventListener(
      "flutterInAppWebViewPlatformReady",
      // eslint-disable-next-line no-unused-vars
      function (event) {
        that.isFlutter = true;
      }
    );
    if (window.flutter_inappwebview) {
      that.isFlutter = true;
    }
    // console.log("isFlutter" + that.isFlutter);
    // console.log(this.$route.params.sourceId);
    // console.log(this.$route.query.token);
    // console.log(localStorage.getItem("token"));
    that.sourceId = that.$route.params.sourceId;
    that.token = that.$route.query.token
      ? that.$route.query.token
      : localStorage.getItem("token");
    that.isToken();
  },
  methods: {
    //  跳转协议
    agreement() {
      window.location.href = URL + "preview/protocol/settle.html";
    },
    //上传图片
    uploadImg(e, type) {
      let _this = this;
      if (type != 1) {
        _this.autoCropWidth = 327; // 默认生成截图框宽度
        _this.autoCropHeight = 184; // 默认生成截图框高度
      } else {
        _this.autoCropWidth = 320; // 默认生成截图框宽度
        _this.autoCropHeight = 320; // 默认生成截图框高度
      }
      _this.up_type = type;
      let file = e.target.files[0];
      console.log(file);
      if (!/\.(gif|jpg|jpeg|png|bmp|GIF|JPG|PNG)$/.test(e.target.value)) {
        alert("图片类型必须是.gif,jpeg,jpg,png,bmp中的一种");
        return false;
      }
      let reader = new FileReader();
      // reader.readAsDataURL(file);
      reader.onload = (e) => {
        let data;
        if (typeof e.target.result === "object") {
          // console.log("object");
          // 把Array Buffer转化为blob 如果是base64不需要
          data = window.URL.createObjectURL(new Blob([e.target.result]));
        } else {
          data = e.target.result;
        }
        _this.showShadow = true;
        // console.log(123);
        _this.imgUrl = data;
        // console.log(_this.imgUrl);
        _this.$nextTick(() => {
          if (type == 1) {
            // 防止第二次传同图片，不触发uploadChange
            _this.$refs.files.value = "";
          } else {
            _this.$refs.filesff.value = "";
          }
        });
      };
      // 转化为blob
      reader.readAsArrayBuffer(file);
    },
    sure(val) {
      let _this = this;
      // _this.loading = true;
      // let keys = new Date().getTime() + ".png";
      let keys = fileRandomKey(".png");
      axios
        .request({
          url: "https://upload.qiniup.com/putb64/-1/key/" + Base64.encode(keys),
          method: "post",
          data: val.split(";base64,")[1],
          headers: {
            "Content-Type": "application/octet-stream",
            Authorization: "UpToken " + _this.uptoken,
          },
        })
        .then(function (res) {
          // console.log(res);
          if (_this.up_type == 1) {
            _this.headImg = qiniuimgZone + res.data.key + _this.tailHead;
          } else {
            _this.idImg = qiniuimgZone + res.data.key;
          }
          _this.showShadow = false;
          // _this.loading = false;
          showLoadingToast({
            message: "图片上传中，请稍候...",
            forbidClick: true,
            loadingType: "spinner",
            duration: 100,
          });
        });
    },
    cancel() {
      this.showShadow = false;
    },
    fetchImgToken() {
      getQiniuToken(
        {},
        {
          token: this.token,
          version: this.version || "1.0.0",
          "client-type": "3",
          "device-imei": "1",
        }
      )
        .then((res) => {
          // console.log(res);
          this.uptoken = res.data.data.uptoken;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 判断token是否过期
    isToken() {
      let that = this;
      let params = {
        token: that.token,
      };
      tokenExpire(params, {
        version: that.version || "1.0.0",
        "client-type": "3",
        "device-imei": "1",
      }).then((res) => {
        // console.log(res);
        if (res.data.data > 0) {
          //  token登录状态不必登录
          that.tokenLog = 1;
          that.getInfoData();
        } else {
          //  token已过期
          that.tokenLog = 0;
        }
      });
    },
    //  根据token获取用户信息
    getInfoData() {
      let that = this;
      let params = {
        token: that.token,
      };
      let strNum = generatekey(16);
      getInfo(
        params,
        {
          version: that.version || "1.0.0",
          "client-type": "3",
          "device-imei": "1",
          token: that.token,
        },
        encrypt(strNum)
      )
        .then((res) => {
          let info = res.data.data;
          that.phone = decryptAes(info.mobile, strNum);
          that.userId = info.userId;
          // console.log(info);
          if (info.userId) {
            that.getStatus();
            that.fetchImgToken();
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    //  判断用户申请状态
    getStatus() {
      let that = this;
      let params = {};
      getStatusByUser(params, {
        token: that.token,
        version: that.version || "1.0.0",
        "client-type": "3",
        "device-imei": "1",
      }).then((res) => {
        // console.log(res);
        if (res.data.code == 0) {
          that.statusInfo = res.data.data;
          let data = res.data.data;
          if (data) {
            if (data.ownedSubChannelId) {
              if (data.ownedSubChannelStatus == "closed") {
                // 注销
                // console.log("注销：" + that.isApp);
                if (that.isApp) {
                  showDialog({
                    title: "",
                    message: "您的账号已被注销，请联系客服恢复",
                    confirmButtonText: "联系客服",
                    confirmButtonColor: "#1788EE",
                    closeOnPopstate: false,
                  }).then(() => {
                    if (_isHarmonyOS()) {
                      // eslint-disable-next-line no-undef
                      JSBridgeHandle.goTel({
                        phoneNum: "0531-85193607",
                      });
                    }
                    if (that.isFlutter) {
                      window.flutter_inappwebview
                        .callHandler("goTel", {
                          phoneNum: "0531-85193607",
                        })
                        .then(function (result) {
                          console.log(result);
                        });
                    }
                  });
                } else {
                  showDialog({
                    title: "",
                    message: "您的账号已被注销，请下载大众APP联系客服",
                    confirmButtonText: "下载APP",
                    confirmButtonColor: "#1788EE",
                    closeOnPopstate: false,
                  }).then(() => {
                    window.location.href =
                      URL +
                      "share/shareDown/" +
                      that.userId +
                      "?userId=" +
                      that.userId;
                  });
                }
              } else {
                // 已入驻
                //  修改申请
                if (that.isApp) {
                  that.showTheme = 1;
                  that.getInfo();
                } else {
                  showDialog({
                    title: "提示",
                    message: "您已申请大众号，请下载大众APP发布文章",
                    confirmButtonText: "下载APP",
                    confirmButtonColor: "#1788EE",
                    closeOnPopstate: false,
                  }).then(() => {
                    window.location.href =
                      URL +
                      "share/shareDown/" +
                      that.userId +
                      "?userId=" +
                      that.userId;
                  });
                }
                if (data.currentApplicationType == "modify") {
                  if (data.currentApplicationStatus == "reject") {
                    //  修改申请
                    if (that.isApp) {
                      that.showTheme = 1;
                      that.getInfo();
                    } else {
                      showDialog({
                        title: "提示",
                        message: "您已申请大众号，请下载大众APP发布文章",
                        confirmButtonText: "下载APP",
                        confirmButtonColor: "#1788EE",
                        closeOnPopstate: false,
                      }).then(() => {
                        window.location.href =
                          URL +
                          "share/shareDown/" +
                          that.userId +
                          "?userId=" +
                          that.userId;
                      });
                    }
                  } else {
                    //  修改审核中
                    if (that.isApp) {
                      showDialog({
                        title: "提示",
                        message: "您的修改资料申请正在审核中",
                        confirmButtonText: "知道了",
                        confirmButtonColor: "#1788EE",
                      }).then(() => {
                        if (_isHarmonyOS()) {
                          // eslint-disable-next-line no-undef
                          JSBridgeHandle.submitSuccess({});
                        }
                        if (that.isFlutter) {
                          window.flutter_inappwebview
                            .callHandler("submitSuccess", {})
                            // eslint-disable-next-line no-unused-vars
                            .then(function (result) {});
                        }
                      });
                    } else {
                      showDialog({
                        title: "提示",
                        message:
                          "您的修改资料申请正在审核中，请下载大众APP查看",
                        confirmButtonText: "下载APP",
                        confirmButtonColor: "#1788EE",
                        closeOnPopstate: false,
                      }).then(() => {
                        window.location.href =
                          URL +
                          "share/shareDown/" +
                          that.userId +
                          "?userId=" +
                          that.userId;
                      });
                    }
                  }
                }
              }
            } else {
              //  未入驻大众号
              that.showTheme = 0;
              if (data.currentApplicationType == "register") {
                if (data.currentApplicationStatus == "waiting") {
                  //  审核中
                  if (that.isApp) {
                    showDialog({
                      title: "提示",
                      message: "您的入驻申请正在审核中",
                      confirmButtonText: "知道了",
                      confirmButtonColor: "#1788EE",
                    }).then(() => {
                      if (_isHarmonyOS()) {
                        // eslint-disable-next-line no-undef
                        JSBridgeHandle.submitSuccess({});
                      }
                      if (that.isFlutter) {
                        window.flutter_inappwebview
                          .callHandler("submitSuccess", {})
                          // eslint-disable-next-line no-unused-vars
                          .then(function (result) {});
                      }
                    });
                  } else {
                    showDialog({
                      title: "提示",
                      message: "您的入驻申请正在审核中，请下载大众APP查看",
                      confirmButtonText: "下载APP",
                      confirmButtonColor: "#1788EE",
                      closeOnPopstate: false,
                    }).then(() => {
                      window.location.href =
                        URL +
                        "share/shareDown/" +
                        that.userId +
                        "?userId=" +
                        that.userId;
                    });
                  }
                } else {
                  //  未入驻
                  that.showTheme = 0;
                }
              }
            }
          }
        }
      });
    },

    //  顶象验证
    getCode(phone) {
      let that = this;
      if (!phone && !that.reg_tel.test(phone)) {
        return false;
      } else {
        // 先进行人机验证
        // eslint-disable-next-line no-undef
        let myCaptcha = _dx.Captcha(document.getElementById("c1"), {
          appId: "c9df629fddc9f71df2033f8ee291fba5", //appId，在控制台中“应用管理”或“应用配置”模块获取
          style: "popup",
          success: (token) => {
            console.log(token);
            myCaptcha.hide();
            let params = {
              mobile: encrypt(phone),
              verifyToken: token,
              // type: "sms_login_code",
            };
            sendCode(params, {
              version: that.version || "1.0.0",
              "client-type": "3",
              "device-imei": "1",
            }).then((res) => {
              // console.log(res);
              if (res.data.code == 0) {
                // 验证码发送逻辑
                that.timeFlag = false;
                toast("短信验证码发送成功,请注意查收", 1500);
                // 开始倒计时
                that.timer = setInterval(() => {
                  if (that.time > 0) {
                    that.time--;
                  } else {
                    that.time = 60;
                    that.timeFlag = true;
                    clearInterval(that.timer);
                    that.timer = null;
                    that.code = "";
                  }
                }, 1000);
              } else {
                that.timeFlag = true;
                toast(res.data.message, 1500);
              }
            });
          },
        });
        myCaptcha.show();
      }
    },
    submitForm() {
      let that = this;
      if (!that.checked) {
        toast("请勾选入驻协议");
        return;
      }
      // 授权并登录 先做非空验证
      if (that.reg_tel.test(that.phone) && that.phone && that.code) {
        let obj = {
          mobile: encrypt(that.phone.toString().trim()),
          verifyCode: that.code.toString().trim(),
        };
        loginSms(obj, {
          version: that.version || "1.0.0",
          "client-type": "3",
          "device-imei": "1",
        }).then((res) => {
          // console.log(res);
          if (res.data.code == 0) {
            // 拿到access_token   res.data.data.access_token
            that.token = res.data.data.access_token;
            localStorage.setItem("token", res.data.data.access_token);
            that.tokenLog = 1;
            that.getInfoData();
          } else {
            // that.tokenLog = 0;
            toast(res.data.message);
          }
        });
      } else {
        return false;
      }
    },
    //  获取大众号列表 getTypeList
    getTypeLi() {
      let that = this;
      let params = {
        pageNo: 0,
        pageSize: 20,
        start: 0,
        end: 0,
        classificationId: 0,
        subChannelName: "",
      };
      getTypeList(params, {
        version: that.version ? that.version : "1.0.0",
      }).then((res) => {
        // console.log(res);
        let data = res.data.data;
        data.forEach((item) => {
          // console.log(item);
          that.typeLists.forEach((itemS) => {
            if (item.name == itemS.name) {
              item.desc = itemS.desc;
            }
          });
        });
        that.typeList = data;
        console.log(that.typeList);
      });
    },
    //  获取入驻信息
    getInfo() {
      let that = this;
      let data = {
        appId: "",
      };
      getSubChannelDetailByUser(data, {
        token: that.token,
        version: that.version || "1.0.0",
        "client-type": "3",
        "device-imei": "1",
      })
        .then((res) => {
          // console.log(res);
          if (res.data.code == 0) {
            let info = res.data.data;
            that.publicId = info.subChannelId;
            document.title = that.publicId
              ? "修改信息"
              : `申请入驻${that.title}`;
            that.enterType = info.classificationId;
            that.headImg = info.logo;
            that.publicName = info.name;
            that.info = info.description;
            that.nameUnit = info.unitName;
            that.name = info.operatorName;
            that.province = info.provinceCode;
            that.city = info.cityCode;
            that.cascaderValue = info.cityCode;
            let proName = that.options.find(
              (item) => item.id == info.provinceCode
            );
            let cityName = proName.childrenNodes.find(
              (item) => item.id == info.cityCode
            );
            // console.log(proName.name);
            // console.log(cityName.name);
            that.fieldValue = proName.name + "/" + cityName.name;
            if (info.classificationId == 1) {
              that.idImg = info.idcardImg;
            } else {
              that.idImg = info.authorizationImg;
            }
          } else {
            that.publicId = "";
            that.enterType = "";
            that.headImg = "";
            that.publicName = "";
            that.info = "";
            that.nameUnit = "";
            that.name = "";
            that.province = "";
            that.city = "";
            that.cascaderValue = "";
            that.fieldValue = "";
            that.idImg = "";
          }
        })
        // eslint-disable-next-line no-unused-vars
        .catch((err) => {
          toast("请稍后重试！", 2000);
        });
    },
    //  选择账号类型
    goTheme(info) {
      let that = this;
      that.title = info.name;
      that.toastTxt = info.desc || "点击上传组织机构代码证或统一社会信用代码证";
      that.enterType = info.classificationId;
      that.showTheme = 1;
      document.title = that.publicId ? "编辑资料" : `申请入驻${that.title}`;
      // 切换页面时滚动条自动滚动到顶部
      // this.$nextTick(() => {
      window.scrollTo(0, 0);
      // });
    },

    // 提交信息
    submitInfo() {
      let that = this;
      if (!that.headImg) {
        toast("请上传大众号头像");
      } else if (!that.publicName) {
        toast("请填写大众号名称");
      } else if (that.publicName.length < 2) {
        toast("大众号名称不得少于2个字");
      } else if (that.publicName.length > 15) {
        toast("大众号名称不得超过15个字");
      } else if (!that.fieldValue) {
        toast("请选择城市");
      } else if (!that.info) {
        toast("请填写简介");
      } else if (that.info.length > 200) {
        toast("简介200字以内");
      } else if (!that.name) {
        if (that.enterType == 1) {
          toast("请填写真实姓名");
        } else {
          toast("请填写联系人姓名");
        }
      } else if (that.name.length > 10) {
        if (that.enterType == 1) {
          toast("真实姓名10字以内");
        } else {
          toast("联系人姓名10字以内");
        }
      } else if (!that.idImg) {
        toast("请" + that.toastTxt.slice(2));
      } else if (that.enterType != 1 && !that.nameUnit) {
        toast("请填写单位名称");
      } else if (that.enterType != 1 && that.nameUnit.length > 30) {
        toast("单位名称30字以内");
      } else {
        if (that.publicId) {
          that.submitId();
        } else {
          that.submit();
        }
      }
    },
    // 修改信息提交
    submitId() {
      let that = this;
      let params = {
        classificationId: that.enterType, // 大众号类型
        name: that.publicName, // 大众号名称
        logo: that.headImg, // 大众号logo
        description: that.info, // 大众号简介
        provinceCode: that.fieldValue ? that.province : "", // 所属省code
        cityCode: that.fieldValue ? that.city : "", // 所属市code
        operatorName: that.name, // 运营者名称
        operatorMobile: that.phone, // 运营者手机号
        operatorIdcard: "", // 运营者身份证号
        // idcardImg: that.enterType == 1 ? that.idImg : "", // 身份证图片
        idcardImg: "", // 身份证图片
        unitName: that.nameUnit ? that.nameUnit : "", // 单位名称
        unitMobile: "", // 单位电话
        usciCode: "", // 统一社会信用代码
        // authorizationImg: that.enterType != 1 ? that.idImg : "", // 大众授权书图片
        authorizationImg: "", // 大众授权书图片
        registerSourceId: "", // 注册来源id
        subChannelId: "", // 大众号id
      };
      if (that.enterType == 1) {
        params.idcardImg = that.idImg;
      } else {
        params.authorizationImg = that.idImg;
      }
      modify(params, {
        token: that.token,
        version: that.version || "1.0.0",
        "client-type": "3",
        "device-imei": "1",
      })
        .then((res) => {
          // console.log(res);
          if (res.data.code == 0) {
            showDialog({
              title: "提交成功",
              message:
                "预计3个工作日内完成审核，审核结果以系统通知形式告知您，请注意查看",
              confirmButtonText: "知道了",
              confirmButtonColor: "#1788EE",
            }).then(() => {
              if (_isHarmonyOS()) {
                // eslint-disable-next-line no-undef
                JSBridgeHandle.submitSuccess({});
              }
              if (this.isFlutter) {
                window.flutter_inappwebview
                  .callHandler("submitSuccess", {})
                  // eslint-disable-next-line no-unused-vars
                  .then(function (result) {});
              }
              if (!that.isApp) {
                location.reload();
              }
            });
          } else {
            toast(res.data.message, 2000);
          }
        })
        // eslint-disable-next-line no-unused-vars
        .catch((err) => {
          toast("请稍后重试！", 2000);
        });
    },
    // 未注册提交入驻信息
    submit() {
      let that = this;
      let params = {
        classificationId: that.enterType, // 大众号类型
        name: that.publicName, // 大众号名称
        logo: that.headImg, // 大众号logo
        description: that.info, // 大众号简介
        provinceCode: that.fieldValue ? that.province : "", // 所属省code
        cityCode: that.fieldValue ? that.city : "", // 所属市code
        operatorName: that.name, // 运营者名称
        operatorMobile: that.phone, // 运营者手机号
        operatorIdcard: "", // 运营者身份证号
        idcardImg: "", // 身份证图片
        unitName: that.nameUnit ? that.nameUnit : "", // 单位名称
        unitMobile: "", // 单位电话
        usciCode: "", // 统一社会信用代码
        authorizationImg: "", // 大众授权书图片
        registerSourceId: "", // 注册来源id
        sharingCode: that.sourceId, // 分享码
      };
      if (that.enterType == 1) {
        params.idcardImg = that.idImg;
      } else {
        params.authorizationImg = that.idImg;
      }
      register(params, {
        token: that.token,
        version: that.version || "1.0.0",
        "client-type": "3",
        "device-imei": "1",
      })
        .then((res) => {
          // console.log(res);
          if (res.data.code == 0) {
            showDialog({
              title: "提交成功",
              message:
                "预计3个工作日内完成审核，审核结果以短信形式通知您，请注意查收！",
              confirmButtonText: "知道了",
              confirmButtonColor: "#1788EE",
            }).then(() => {
              // on close   submitSuccess
              if (_isHarmonyOS()) {
                // eslint-disable-next-line no-undef
                JSBridgeHandle.submitSuccess({});
              }
              if (this.isFlutter) {
                window.flutter_inappwebview
                  .callHandler("submitSuccess", {})
                  // eslint-disable-next-line no-unused-vars
                  .then(function (result) {});
              }
              if (!that.isApp) {
                location.reload();
              }
            });
          } else {
            toast(res.data.message, 2000);
          }
        })
        // eslint-disable-next-line no-unused-vars
        .catch((err) => {
          toast("请稍后重试！", 2000);
        });
    },

    //  城市选择
    onChange(val) {
      console.log(val);
      // console.log(this.cascaderValue);
    },
    getAreaList() {
      let that = this;
      let data = {};
      areaList(data)
        .then((res) => {
          if (res.data.code == 0) {
            let area = res.data.data;
            that.options = area;
          } else {
            toast(res.data.message, 2000);
          }
        })
        // eslint-disable-next-line no-unused-vars
        .catch((err) => {
          toast("请稍后重试！", 2000);
        });
    },
    // 选择城市结果
    onFinish(e) {
      this.showCity = false;
      if (e.selectedOptions[0].childrenNodes) {
        if (e.selectedOptions.length) {
          // 省
          this.province = e.selectedOptions[0].id;
          this.city = e.selectedOptions[1].id;
          this.district = "";
          if (e.selectedOptions[1].name == e.selectedOptions[0].name) {
            // 直辖市
            this.fieldValue = e.selectedOptions
              .slice(1)
              .map((option) => option.name)
              .join("/");
          } else {
            this.fieldValue = e.selectedOptions
              .map((option) => option.name)
              .join("/");
          }
        } else {
          this.fieldValue = e.selectedOptions
            .slice(1)
            .map((option) => option.name)
            .join("/");
        }
      } else {
        this.fieldValue = e.selectedOptions
          .map((option) => option.name)
          .join("/");
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@import "../assets/fonts/fonts.css";
/*登录页面*/
.login {
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.7);
  position: fixed;
  top: 0;
  left: 0;
  z-index: 99;
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: "FZBIAOYSJW";
  /*font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;*/
  .apply-con-top {
    width: 280px;
    height: 281px;
    background-color: #ffffff;
    border-radius: 8px;
    background-image: url("https://img.qiluyidian.net/dM6C7h_1699512195416.png");
    background-position: left top;
    background-repeat: no-repeat;
    background-size: 100% auto;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    transform: scale(1);
    .p {
      width: 100%;
      text-align: center;
      font-size: 19px;
      color: #202022;
      line-height: 26px;
      margin-bottom: 16px;
      font-family: "FZCYSJW";
    }
    .name-con {
      width: 251px;
      height: 44px;
      background: #f7f8f9;
      box-shadow: inset 0 0 0 0 #f1f2f3;
      border-radius: 4px;
      .name-input {
        width: calc(100% - 32px);
        height: 44px;
        background: #f7f8f9;
        line-height: 44px;
        padding: 0 16px;
        font-size: 17px;
        color: #b1b1bb;
        border-radius: 4px;
        input {
          width: 100%;
          height: 42px;
          background: rgba(0, 0, 0, 0);
          outline: 0;
          resize: none;
          border: none;
          font-size: 17px;
          color: #202022;
          line-height: 44px;
          padding: 0 0 !important;
        }
        input::-webkit-input-placeholder {
          /* WebKit browsers */
          color: #b1b1bb;
        }
        input:-moz-placeholder {
          /* Mozilla Firefox 4 to 18 */
          color: #b1b1bb;
        }
        input::-moz-placeholder {
          /* Mozilla Firefox 19+ */
          color: #b1b1bb;
        }
        input::-ms-input-placeholder {
          /* Internet Explorer 10+ */
          color: #b1b1bb;
        }
      }
    }
    .name-code {
      width: 251px;
      height: 44px;
      background: #f7f8f9;
      box-shadow: inset 0 0 0 0 #f1f2f3;
      border-radius: 4px;
      margin-top: 8px;
      .code-input {
        width: calc(100% - 32px);
        height: 44px;
        background: #f7f8f9;
        line-height: 44px;
        padding: 0 16px;
        font-size: 17px;
        color: #b1b1bb;
        border-radius: 4px;
        position: relative;
        input {
          width: 60%;
          height: 44px;
          background: rgba(0, 0, 0, 0);
          outline: 0;
          resize: none;
          border: none;
          font-size: 17px;
          color: #202022;
          line-height: 44px;
          padding: 0 !important;
        }
        input::-webkit-input-placeholder {
          /* WebKit browsers */
          color: #b1b1bb;
        }
        input:-moz-placeholder {
          /* Mozilla Firefox 4 to 18 */
          color: #b1b1bb;
        }
        input::-moz-placeholder {
          /* Mozilla Firefox 19+ */
          color: #b1b1bb;
        }
        input::-ms-input-placeholder {
          /* Internet Explorer 10+ */
          color: #b1b1bb;
        }
        .btnCode {
          width: 80px;
          height: 44px;
          font-size: 14px;
          color: #202022;
          line-height: 44px;
          text-align: right;
          position: absolute;
          right: 12px;
          top: 0;
        }
      }
    }
    .bom-txt {
      color: #b1b1bb;
      margin-top: 16px;
      margin-bottom: 24px;
      font-size: 12px;
      line-height: 16px;
      width: 251px;
    }
    .but {
      width: 160px;
      height: 40px;
      background: #f21333;
      border-radius: 4px;
      font-size: 17px;
      color: #fff;
      line-height: 40px;
      text-align: center;
    }
  }
}
/*类型列表*/
.type-con {
  font-family: "FZBIAOYSJW";
  height: auto;
  min-height: calc(100vh - 40px);
  background: #f2f4f5;
  .type-list {
    width: 100%;
    margin: auto;
    height: auto;
    min-height: calc(100vh - 54px);
    background: #ffffff;
    padding-top: 16px;
    padding-bottom: 34px;
    .title-top {
      width: calc(100% - 32px);
      margin: 0 auto 6px;
      font-size: 14px;
      color: #909099;
      line-height: 20px;
    }
    .item-type {
      width: calc(100% - 32px);
      height: 56px;
      margin: auto;
      background: #ffffff;
      border-bottom: 0.5px solid #f1f3f4;
      font-size: 17px;
      color: #202022;
      line-height: 56px;
      text-align: center;
    }
  }
}
/*正文页面*/
.certificate {
  font-family: "FZBIAOYSJW";
  height: auto;
  min-height: calc(100vh - 16px);
  background: #f2f4f5;
  padding: 16px 0 89px;

  .mg {
    margin: 20px 0 0;
  }

  .mg-tea {
    margin: 20px 0 0;
  }
  .big-title {
    font-size: 15px;
    color: #000000;
    line-height: 18px;
    margin: 0 12px 12px;
    font-family: "FZCYSJW";
  }

  .apply-con-top {
    width: auto;
    height: auto;
    background: #ffffff;
    /*border-radius: 8px;*/
    /*margin: 0 8px;*/
    padding: 16px;
    .title-t {
      font-size: 14px;
      color: #909099;
      margin: 0 0 9px;
    }
    .head-con {
      .head-content {
        width: 60px;
        height: 60px;
        border-radius: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        font-size: 15px;
        line-height: 20px;
        font-weight: normal;
        overflow: hidden;
        cursor: pointer;
        position: relative;
        .file {
          width: 100%;
          height: 100%;
          position: absolute;
          top: 0;
          left: 0;
          z-index: 99;
        }

        .head-img {
          width: 100%;
          height: 100%;
          border-radius: 50%;
          object-fit: cover;
          position: absolute;
          top: 0;
          left: 0;
          z-index: 9;
        }

        .txt-img {
          width: 100%;
          height: 100%;
          border-radius: 6px;
          position: absolute;
          top: 0;
          left: 0;
          z-index: 9;
        }
      }
    }

    .name-con {
      .name-input {
        width: calc(100% - 32px);
        height: 44px;
        background: #f7f8f9;
        border-radius: 23px;
        line-height: 44px;
        padding: 0 16px;
        font-size: 16px;
        color: #b1b1bb;

        input {
          width: 100%;
          height: 44px;
          background: rgba(0, 0, 0, 0);
          outline: 0;
          resize: none;
          border: none;
          font-size: 16px;
          color: #202022;
          line-height: 44px;
          padding: 0 0 !important;
        }

        input::-webkit-input-placeholder {
          /* WebKit browsers */
          color: #b1b1bb;
        }

        input:-moz-placeholder {
          /* Mozilla Firefox 4 to 18 */
          color: #b1b1bb;
        }

        input::-moz-placeholder {
          /* Mozilla Firefox 19+ */
          color: #b1b1bb;
        }

        input::-ms-input-placeholder {
          /* Internet Explorer 10+ */
          color: #b1b1bb;
        }
      }
      .name-input-s {
        width: calc(100% - 32px);
        height: 44px;
        background: #f7f8f9;
        border-radius: 23px;
        line-height: 44px;
        padding: 0 16px;
        color: #202022;
        font-size: 16px;
        display: flex;
        justify-content: space-between;
      }
      .down {
        width: 82px;
        height: 36px;
        /*background: rgba(209, 231, 252, 0.5);*/
        background: #fff;
        border-radius: 23px;
        font-size: 16px;
        color: #1788ee;
        line-height: 36px;
        text-align: center;
        margin-top: 4px;
      }
    }

    .inr-con {
      .inr-input {
        width: calc(100% - 32px);
        height: 170px;
        background: #f7f8f9;
        border-radius: 8px;
        padding: 12px 16px;
        margin: 20px auto 0;

        textarea {
          background: #f7f8f9;
          width: 100%;
          height: 170px;
          resize: none;
          outline: 0;
          border: none;
          font-size: 16px;
          color: #202022;
          padding: 0 !important;
        }

        textarea::-webkit-input-placeholder {
          /* WebKit browsers */
          color: #b1b1bb;
        }

        textarea:-moz-placeholder {
          /* Mozilla Firefox 4 to 18 */
          color: #b1b1bb;
        }

        textarea::-moz-placeholder {
          /* Mozilla Firefox 19+ */
          color: #b1b1bb;
        }

        textarea::-ms-input-placeholder {
          /* Internet Explorer 10+ */
          color: #b1b1bb;
        }
      }
    }

    .img-cons {
      .img-con {
        width: 100%;
        height: 184px;
        background: #f7f8f9;
        border-radius: 8px;
        display: flex;
        justify-content: center;
        flex-direction: column;
        align-items: center;

        overflow: hidden;
        cursor: pointer;
        position: relative;
        .file {
          width: 100%;
          height: 100%;
          position: absolute;
          top: 0;
          left: 0;
          z-index: 99;
        }
        img {
          width: auto;
          height: 86px;
          margin-bottom: 8px;
        }

        p {
          font-size: 14px;
          color: #b1b1bb;
          margin: 0;
        }
      }

      .img-item {
        width: 100%;
        height: 184px;
        overflow: hidden;
        position: relative;
        border-radius: 8px;
        .file {
          width: 100%;
          height: 100%;
          position: absolute;
          top: 0;
          left: 0;
          z-index: 99;
        }
        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          position: absolute;
          top: 0;
          left: 0;
        }

        .txt-img {
          width: 48px;
          height: 28px;
          font-size: 12px;
          color: #ffffff;
          line-height: 28px;
          text-align: center;
          background: rgba(0, 0, 0, 0.7);
          border-radius: 23px;
          position: absolute;
          bottom: 12px;
          left: calc(50% - 24px);
        }
      }
    }

    .yl-type {
      .name-input {
        width: calc(100% - 32px);
        height: 44px;
        background: #f7f8f9;
        border-radius: 23px;
        line-height: 44px;
        padding: 0 16px;
        font-size: 16px;
        color: #b1b1bb;
      }
    }
    .yl-pop {
      position: relative;
      .name-input {
        width: calc(100% - 32px);
        height: 44px;
        background: #f7f8f9;
        border-radius: 23px;
        line-height: 44px;
        padding: 0 16px;
        font-size: 16px;
        color: #b1b1bb;
      }
      .search-con {
        padding: 26px 16px 0;
        background: #ffffff;
        box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.1);
        border-radius: 8px;
        border: 1px solid #f7f8f9;
        filter: blur(0px);
        width: calc(100% - 32px);
        height: auto;
        max-height: 178px;
        overflow: scroll;
        line-height: 22px;
        font-size: 16px;
        color: #202022;
        position: absolute;
        top: 72px;
        left: 0;
        z-index: 2;
        .search-list {
          margin-bottom: 16px;
        }
      }
    }

    .name-code {
      display: flex;
      justify-content: space-between;
      .code-input {
        width: 155px;
        height: 44px;
        background: #f7f8f9;
        border-radius: 23px;
        line-height: 44px;
        padding: 0 16px;
        font-size: 16px;
        color: #b1b1bb;
        input {
          width: 100%;
          height: 44px;
          background: rgba(0, 0, 0, 0);
          outline: 0;
          resize: none;
          border: none;
          font-size: 16px;
          color: #202022;
          line-height: 44px;
        }

        input::-webkit-input-placeholder {
          /* WebKit browsers */
          color: #b1b1bb;
        }

        input:-moz-placeholder {
          /* Mozilla Firefox 4 to 18 */
          color: #b1b1bb;
        }

        input::-moz-placeholder {
          /* Mozilla Firefox 19+ */
          color: #b1b1bb;
        }

        input::-ms-input-placeholder {
          /* Internet Explorer 10+ */
          color: #b1b1bb;
        }
      }
      .btnCode {
        width: 140px;
        height: 44px;
        font-size: 17px;
        line-height: 44px;
        text-align: center;
      }
    }
  }
  .but-con {
    width: 100%;
    height: 44px;
    background: rgba(255, 255, 255, 1);
    box-shadow: inset 0px 1px 0px 0px rgba(228, 228, 228, 0.8);
    /*backdrop-filter: blur(10px);*/
    padding-top: 5px;
    padding-bottom: 34px;
    position: fixed;
    bottom: 0;
    z-index: 99;

    .but {
      width: 200px;
      height: 44px;
      background: #f21333;
      font-size: 18px;
      font-weight: bold;
      color: #ffffff;
      line-height: 44px;
      text-align: center;
      border-radius: 22px;
      margin: auto;
    }
    .gray {
      background: #d9d9dd;
    }
  }
}
.shadow {
  width: 100vw;
  max-width: 375px;
  height: 100vh;
  background: rgba(0, 0, 0, 0.6);
  position: fixed;
  top: 0;
  left: 0;
  align-items: center;
  display: flex;
  justify-content: center;
  z-index: 99999;
}
.loading {
  width: 100vw;
  max-width: 375px;
  height: 100vh;
  background: rgba(0, 0, 0, 0.6);
  position: fixed;
  align-items: center;
  display: flex;
  justify-content: center;
  z-index: 999;
}
</style>
<style lang="scss">
.van-search {
  box-sizing: content-box !important;
}
.van-icon-search:before {
  content: "" !important;
  position: relative;
}
.van-field__left-icon {
  margin-right: 0 !important;
}
.van-search__content {
  padding-left: 0 !important;
  height: 44px !important;
  line-height: 44px !important;
}
.van-search .van-cell {
  padding: 0 !important;
}
.van-dropdown-menu__bar {
  background-color: rgba(0, 0, 0, 0) !important;
  box-shadow: none !important;
}
/*vant覆盖默认样式的写法*/
::v-deep .van-cell:not(:last-child)::after {
  left: 0 !important;
}
.img-icon {
  height: 20px;
}
.van-radio-group {
  height: 44px !important;
}
.van-cell {
  box-sizing: content-box !important;
}
.van-cell::after {
  border-bottom: none !important;
}
.van-field__control {
  color: #202022 !important;
}
.van-field__body {
  height: 44px;
  line-height: 44px;
  font-size: 16px;
  input::-webkit-input-placeholder {
    /* WebKit browsers */
    color: #b1b1bb;
  }

  input:-moz-placeholder {
    /* Mozilla Firefox 4 to 18 */
    color: #b1b1bb;
  }

  input::-moz-placeholder {
    /* Mozilla Firefox 19+ */
    color: #b1b1bb;
  }

  input::-ms-input-placeholder {
    /* Internet Explorer 10+ */
    color: #b1b1bb;
  }
}
.van-icon-arrow:before {
  content: "" !important;
  position: relative;
}
.location-o {
  line-height: 44px;
  position: absolute;
  /*right: 20px;*/
  /*bottom: 0;*/
  left: 90%;
  bottom: 52px;
}
.van-checkbox__icon .van-icon {
  width: 12px !important;
  height: 12px !important;
  font-size: 12px !important;
  line-height: 14px !important;
  box-sizing: inherit !important;
}
.van-checkbox__label {
  color: #b1b1bb !important;
  margin-left: 6px !important;
  font-size: 12px !important;
}
.van-checkbox__icon {
  display: flex;
  justify-content: center;
  align-items: center;
}
.van-tabs__line {
  background: #f21333 !important;
}
.van-cascader__option {
  font-size: 15px !important;
  padding: 12px var(--van-padding-md) !important;
}
.van-tab__text {
  font-size: 15px !important;
}
.van-cascader__header {
  height: 36px !important;
  align-items: flex-end !important;
}
.van-cascader__close-icon {
  font-size: 24px !important;
}
.van-cascader__option--selected {
  color: #f21333 !important;
}

.dialog-footer {
  display: flex;
  justify-content: space-between;
}
.el-dialog {
  margin-top: 10vh !important;
}
.el-upload {
  width: 60px !important;
  height: 60px !important;
  border-radius: 50%;
}
</style>
